import type { BaseKeyFunction } from "../../../lib";

export const keyHome: BaseKeyFunction = () => ["home"];
